import { useNavigate } from "react-router";
import {
  MarketSearchBar,
  type MarketSearchBarProps,
  type MarketSearchSelection,
} from "~/components/marketSearch/MarketSearchBar";
import { useRemoteFeatureFlags } from "~/hooks/useRemoteFeatureFlags";
import { useStorefrontBuyerPostcode } from "~/pages/stockList/categoryPage/Storefront/lib/useStorefrontBuyerPostcode";
import { useDiscoveryV2SearchStore } from "../v2/DiscoveryV2SearchStore";
import {
  applyMarketSearchSelection,
  buildDiscoverySearchLocation,
} from "./marketSearchState.shared";
import { DiscoveryInput } from "./DiscoveryInput";

export const DiscoveryMarketSearch = ({
  onSubmit,
  initialValue,
  onCommit,
  inputRef,
  autoFocus,
  fallbackSubmitButtonClassName,
  ...props
}: Omit<MarketSearchBarProps, "onSelect"> & {
  initialValue?: string;
  onSubmit: (value: string) => void;
  onCommit?: (selection: MarketSearchSelection) => void;
  fallbackSubmitButtonClassName?: string;
}) => {
  const enabled = useRemoteFeatureFlags().isActive("marketSearchAutocomplete");
  const { buyerPostcode } = useStorefrontBuyerPostcode();
  const navigate = useNavigate();
  if (!enabled) {
    return (
      <DiscoveryInput
        key={initialValue}
        ref={inputRef}
        autoFocus={autoFocus}
        initialValue={initialValue}
        placeholder={props.placeholder}
        inputClassName={props.inputClassName}
        className={props.className}
        containerClassName={props.inputContainerClassName}
        submitButtonClassName={fallbackSubmitButtonClassName}
        label={props.label}
        onSubmit={onSubmit}
      />
    );
  }
  return (
    <MarketSearchBar
      inputRef={inputRef}
      autoFocus={autoFocus}
      {...props}
      postcode={buyerPostcode}
      onSelect={(selection) => {
        const next = applyMarketSearchSelection(
          selection,
          useDiscoveryV2SearchStore.getState(),
        );
        navigate(buildDiscoverySearchLocation(next, window.location.search));
        onCommit?.(selection);
      }}
    />
  );
};
